import { ChangeDetectionStrategy,Component, inject, OnInit, resource, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { firstValueFrom } from 'rxjs';

import { StoreEnvironment } from 'app/shared/graph';

import { DesignerReleaseChannelService } from './designer-release-channel.service';

export interface CreateStoreDialogResult {
    label: string;
    environment: StoreEnvironment;
    designerReleaseChannel: string;
    appId?: string;
}

@Component({
    templateUrl: './create-store-dialog.component.html',
    styleUrls: ['./create-store-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatSelect, MatOption, MatHint, MatError, MatDialogActions, MatButton, MatDialogClose],
})
export class CreateStoreDialogComponent implements OnInit {
    private readonly dialogRef = inject<MatDialogRef<CreateStoreDialogComponent, CreateStoreDialogResult>>(MatDialogRef);
    private readonly designerReleaseChannelService = inject(DesignerReleaseChannelService);

    label: string;
    readonly environment = signal<StoreEnvironment>(StoreEnvironment.Production);
    designerReleaseChannel: string = '';
    environments: string[] = [];
    appId?: string;

    designerReleaseChannels = resource({
        params: () => ({
            environment: this.environment(),
        }),
        loader: async ({ params }) => {
            return await firstValueFrom(this.designerReleaseChannelService.getDesignerReleaseChannels(params.environment));
        },
    });

    ngOnInit(): void {
        for (let storeEnvironment in StoreEnvironment) {
            this.environments.push(storeEnvironment);
        }
    }

    valid() {
        this.dialogRef.close({
            label: this.label,
            appId: this.appId,
            environment: this.environment(),
            designerReleaseChannel: this.designerReleaseChannel,
        });
    }
}
